import { render } from "./ClinicChangeOffcanvas.vue?vue&type=template&id=67339a09&scoped=true"
import script from "./ClinicChangeOffcanvas.vue?vue&type=script&lang=js"
export * from "./ClinicChangeOffcanvas.vue?vue&type=script&lang=js"

import "./ClinicChangeOffcanvas.vue?vue&type=style&index=0&id=67339a09&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67339a09"]])

export default __exports__